import ComposerWithSuggestions from './ComposerWithSuggestions';

export default ComposerWithSuggestions;
